export default "__VITE_ASSET__BqKbFgVb__"